<template>
  <div class="reply-panel">
    <div v-for="item in this.replyChild" :key="item.replyId">
      <replyBar :reply-info="item" :cur-reply-id="curReplyId" @eventReplyCancel="eventReplyCancel" @eventReleaseReply="releaseReply">
        <div v-if="item.child.length > 0">
          <replyPanel :reply-child="item.child" :cur-reply-id="curReplyId" @eventReplyCancel="eventReplyCancel" @eventReleaseReply="releaseReply"></replyPanel>
        </div>
      </replyBar>
    </div>
  </div>
</template>

<script>
import replyBar from "@/components/panel/replyBar";
export default {
name: "replyPanel",
  props:{
    replyChild: Object,
    curReplyId: String
  },
  methods:{
    eventReplyCancel: function (replyId){
      this.$emit('event-reply-cancel', replyId)
    },
    releaseReply: function (htmlStr, opter){
      this.$emit('event-release-reply', htmlStr, opter)
    }
  },
  components:{
    replyBar
  }
}
</script>

<style scoped>
.reply-panel{
  display: block;
}
</style>
